import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFeriadoIns = async (credentials, data) => {
  const body = {
    service: "RNHFeriadoIns",
    params: {
      rnhFeriadoNombre: data?.nombre || null,
      rnhFeriadoTipo: data?.tipo || null
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
